import { useState } from 'react'
import Box from '@mui/joy/Box'
import FormLabel from '@mui/joy/FormLabel'
import { ColorButton } from './ui/ColorButton'
import { TransparencySlider } from './TransparencySlider'
import { LayerUpButton } from './ui/LayerUpButton'
import { LayerDownButton } from './ui/LayerDownButton'
import { DeleteButton } from './ui/DeleteButton'

export const LayerControl = ({ onLayerUp, onLayerDown }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <FormLabel>Layers</FormLabel>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 1,
                    flexGrow: 1,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                    }}
                >
                    <LayerUpButton onClick={onLayerUp} />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                    }}
                >
                    <LayerDownButton onClick={onLayerDown} />
                </Box>
            </Box>
        </Box>
    )
}
